import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import MenuList from "@mui/material/MenuList";
import { hmLightTheme } from "../themes/hmTheme";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  let chipBgColor = "white";
  let textColor = "#000";

  return (
    <Box sx={{ width: "100%" }}>
      {type}
      <Chip
        component="span"
        label={appCounts}
        size="small"
        className="numericText"
        sx={{
          ml: 1,
          float: "right",
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
          backgroundColor: chipBgColor,
          color: textColor,
        }}
      />
    </Box>
  );
};

const PartnersListAside = ({ ...props }) => {
  const selected = props.selected;
  const totalData = props.totalData;
  return (
    <>
      <HmSubHeaderTitle
        title="Partners"
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 1 }}>
          <MenuList component="div" id="list-partner-menus">
            <Link
              to="/counselors"
              style={{
                display: "block",
                padding: "10px 0px 10px 10px",
                fontWeight: "bold",
                marginBottom: 1,
                textDecoration: "none",
                // color: selected === "counselors" ? "#1976d2" : "#000",
                color: "#000",
                background:
                  selected === "counselors"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
              }}
            >
              Counselors
            </Link>
            <Link
              to="/counselorsToApplications"
              style={{
                display: "block",
                padding: "5px 0px 5px 30px",
                marginBottom: 1,
                textDecoration: "none",
                color: "#000",
                background:
                  selected === "counselorsToApplications"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background =
                  selected === "counselorsToApplications"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  selected === "counselorsToApplications"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent")
              }
            >
              Applications
            </Link>
            <Link
              to="/counselorsToLoans"
              style={{
                display: "block",
                padding: "5px 0px 5px 30px",
                marginBottom: 1,
                textDecoration: "none",
                color: "#000",
                background:
                  selected === "counselorsToLoans"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background =
                  selected === "counselorsToLoans"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  selected === "counselorsToLoans"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent")
              }
            >
              Loans
            </Link>
            <hr />
            <Link
              to="/employers"
              style={{
                display: "block",
                padding: "10px 0px 10px 10px",
                fontWeight: "bold",
                marginBottom: 1,
                textDecoration: "none",
                color: "#000",
                background:
                  selected === "employers"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
              }}
            >
              Employers
            </Link>
            {/* employer application  */}
            <Link
              to="/employersToApplications"
              style={{
                display: "block",
                padding: "5px 0px 5px 30px",
                marginBottom: 1,
                textDecoration: "none",
                color: "#000",
                background:
                  selected === "employersToApplications"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background =
                  selected === "employersToApplications"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  selected === "employersToApplications"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent")
              }
            >
              Applications
            </Link>
            <Link
              to="/employersToLoans"
              style={{
                display: "block",
                padding: "5px 0px 5px 30px",
                marginBottom: 1,
                textDecoration: "none",
                color: "#000",
                background:
                  selected === "employersToLoans"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background =
                  selected === "employersToLoans"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  selected === "employersToLoans"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent")
              }
            >
              Loans
            </Link>
            <hr />
            <Link
              to="/vendors"
              style={{
                display: "block",
                padding: "10px 0px 10px 10px",
                fontWeight: "bold",
                marginBottom: 1,
                textDecoration: "none",
                color: "#000",
                background:
                  selected === "vendors"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
              }}
            >
              Vendors
            </Link>
            <Link
              to="/vendorsToApplications"
              style={{
                display: "block",
                padding: "5px 0px 5px 30px",
                marginBottom: 1,
                textDecoration: "none",
                color: "#000",
                background:
                  selected === "vendorsToApplications"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background =
                  selected === "vendorsToApplications"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  selected === "vendorsToApplications"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent")
              }
            >
              Applications
            </Link>
            <Link
              to="/vendorsToLoans"
              style={{
                display: "block",
                padding: "5px 0px 5px 30px",
                marginBottom: 1,
                textDecoration: "none",
                color: "#000",
                background:
                  selected === "vendorsToLoans"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background =
                  selected === "vendorsToLoans"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  selected === "vendorsToLoans"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent")
              }
            >
              Loans
            </Link>
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default PartnersListAside;
